module.exports = __webpack_public_path__ + "static/media/sample1.a6737ecb.png";